import { createGlobalStyle } from 'styled-components';

const BlogPageStyles = createGlobalStyle`
  /* Blogs Page Styles - v2 */
  .blogs-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    background: linear-gradient(135deg, #0a0e27 0%, #1e1b4b 40%, #581c87 100%);
    min-height: 100vh;
  }

  @media (max-width: 768px) {
    .blogs-container {
      padding: 15px;
    }
  }

  .blogs-hero {
    text-align: center;
    padding: 80px 20px;
    background: linear-gradient(135deg, #0a0e27 0%, #1e1b4b 40%, #581c87 100%);
    color: white;
    margin: 0 -20px 60px;
    border-radius: 0 0 20px 20px;
    position: relative;
  }

  .blogs-hero::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(circle at 1px 1px, rgba(255,255,255,0.3) 0.5px, transparent 0);
    background-size: 30px 30px;
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    .blogs-hero {
      padding: 60px 15px;
      margin: 0 -15px 40px;
    }
  }

  .search-section {
    display: flex;
    gap: 20px;
    margin-bottom: 40px;
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    .search-section {
      flex-direction: column;
      gap: 15px;
    }
  }

  .search-box {
    position: relative;
    flex: 1;
    min-width: 250px;
  }

  .search-box input {
    width: 100%;
    padding: 15px 50px 15px 20px;
    border: 2px solid rgba(135,206,235,0.3);
    border-radius: 25px;
    font-size: 16px;
    background: rgba(135,206,235,0.1);
    color: white;
    backdrop-filter: blur(10px);
  }

  .search-box input::placeholder {
    color: rgba(255,255,255,0.7);
  }

  .search-box input:focus {
    outline: none;
    border-color: #87ceeb;
  }

  .search-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #87ceeb;
  }

  .filter-buttons {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    .filter-buttons {
      justify-content: center;
      gap: 8px;
    }
  }

  .filter-button {
    padding: 10px 20px;
    border: 2px solid rgba(135,206,235,0.3);
    background: rgba(135,206,235,0.1);
    color: white;
    border-radius: 25px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
  }

  .filter-button.active {
    background: #87ceeb;
    color: #0a0e27;
    border-color: #87ceeb;
  }

  .filter-button:hover {
    background: #87ceeb;
    color: #0a0e27;
    border-color: #87ceeb;
  }

  .content-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 40px;
  }

  @media (max-width: 968px) {
    .content-grid {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }

  .main-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .section-title {
    font-size: 2rem;
    color: white;
    margin-bottom: 30px;
    font-weight: 700;
    background: linear-gradient(45deg, #00ff41, #00ffff, #ff0080, #ffff00);
    background-size: 300% 300%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
  }

  .section-title::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #00ff41, #00ffff, #ff0080);
    border-radius: 2px;
  }

  .articles-grid {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .article-card {
    background: rgba(135,206,235,0.1);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(135,206,235,0.3);
    border-radius: 20px;
    overflow: hidden;
    transition: all 0.3s ease;
    will-change: transform, opacity;
  }

  .article-card:hover {
    transform: translateY(-5px);
    border-color: rgba(135,206,235,0.5);
    box-shadow: 0 12px 40px rgba(0,0,0,0.2);
  }

  .article-image {
    height: 200px;
    background: linear-gradient(135deg, #87ceeb 0%, #1e3a8a 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .article-content {
    padding: 30px;
  }

  .article-category {
    background: rgba(135,206,235,0.2);
    color: #87ceeb;
    padding: 6px 12px;
    border-radius: 15px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
  }

  .article-title {
    font-size: 1.3rem;
    color: white;
    margin: 15px 0;
    font-weight: 600;
    line-height: 1.3;
  }

  .article-meta {
    display: flex;
    gap: 20px;
    margin: 15px 0;
    color: rgba(255,255,255,0.7);
    font-size: 14px;
  }

  .article-excerpt {
    color: rgba(255,255,255,0.8);
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .read-more-button {
    background: linear-gradient(135deg, #87ceeb 0%, #1e3a8a 100%);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
  }

  .read-more-button:hover {
    box-shadow: 0 8px 25px rgba(135,206,235,0.4);
  }

  .news-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px;
  }

  @media (max-width: 768px) {
    .news-grid {
      grid-template-columns: 1fr;
    }
  }

  .news-card {
    background: rgba(135,206,235,0.1);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(135,206,235,0.3);
    border-radius: 15px;
    overflow: hidden;
    transition: all 0.3s ease;
    will-change: transform, opacity;
  }

  .news-card:hover {
    transform: translateY(-5px);
    border-color: rgba(135,206,235,0.5);
    box-shadow: 0 12px 40px rgba(0,0,0,0.2);
  }

  .news-type {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(135,206,235,0.2);
    color: #87ceeb;
    padding: 6px 12px;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .news-title {
    font-size: 1.1rem;
    color: white;
    margin-bottom: 10px;
    font-weight: 600;
    line-height: 1.4;
  }

  .news-date {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255,255,255,0.7);
    font-size: 0.85rem;
    margin-bottom: 12px;
  }

  .news-excerpt {
    color: rgba(255,255,255,0.8);
    line-height: 1.5;
    margin-bottom: 15px;
    font-size: 0.9rem;
  }

  .news-button {
    background: linear-gradient(135deg, #87ceeb 0%, #1e3a8a 100%);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
  }

  .news-button:hover {
    box-shadow: 0 8px 25px rgba(135,206,235,0.4);
  }

  .sidebar {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .sidebar-card {
    background: rgba(135,206,235,0.1);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(135,206,235,0.3);
    padding: 30px;
    border-radius: 15px;
  }

  .newsletter-card {
    background: linear-gradient(135deg, #87ceeb 0%, #1e3a8a 100%);
    color: white;
    padding: 30px;
    border-radius: 15px;
    text-align: center;
  }

  .newsletter-card input {
    width: 100%;
    padding: 12px;
    margin-bottom: 15px;
    border: none;
    border-radius: 8px;
    background: rgba(255,255,255,0.9);
    color: #1e3a8a;
  }

  .newsletter-card button {
    background: white;
    color: #1e3a8a;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    transition: all 0.3s ease;
  }

  .newsletter-card button:hover {
    background: rgba(255,255,255,0.9);
  }

  .sidebar-card h3 {
    margin-bottom: 20px;
    color: white;
  }

  .sidebar-card button {
    background: rgba(135,206,235,0.1);
    border: 1px solid rgba(135,206,235,0.3);
    color: white;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;
    text-align: left;
    width: 100%;
    transition: all 0.3s ease;
  }

  .sidebar-card button:hover {
    background: rgba(135,206,235,0.2);
    border-color: rgba(135,206,235,0.5);
  }

  .card-padding {
    padding: 20px;
  }

  .meta-flex {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
`;

export default BlogPageStyles;